export default {
  partNoPlaceholder: 'Wprowadź numer części',
  header: 'Proszę zatwierdź',
};
